import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {DateInputDirective} from "../../../../shared/directives/date-input.directive";
import {FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormField, MatInput, MatLabel, MatSuffix} from "@angular/material/input";
import {
  attachAllFormFields,
  forcesSelectData,
  telegramAttachAllAdvertsModalName
} from "./configs/telegram-attach-all-adverts-modal-config";
import {MatOption} from "@angular/material/core";
import {MatSelect} from "@angular/material/select";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {AttachAllDialogData, TelegramAttachAllParams} from "./types/telegram-attach-all-adverts-modal.types";
import {TelegramAttachAllAdvertsService} from "./services/telegram-attach-all-adverts.service";
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle
} from "@angular/material/datepicker";
import {MatButton} from "@angular/material/button";
import {formatDate} from "@angular/common";
import {customDateProvider} from "../../../locale/providers/custom-date.provider";

@Component({
  selector: 'app-telegram-attach-all-adverts-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    DateInputDirective,
    FormsModule,
    MatInput,
    MatSuffix,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatButton
  ],
  templateUrl: './telegram-attach-all-adverts-modal.component.html',
  styleUrl: './telegram-attach-all-adverts-modal.component.scss',
  providers: [ ...customDateProvider ]
})
export class TelegramAttachAllAdvertsModalComponent extends BaseModalComponent {
  private dialogData = inject<AttachAllDialogData>(MAT_DIALOG_DATA);
  private telegramAttachAllService: TelegramAttachAllAdvertsService = inject(TelegramAttachAllAdvertsService);

  public readonly attachAllFormFields = attachAllFormFields;
  public readonly forcesSelectData = forcesSelectData;
  public attachAllFormGroup = new FormGroup({});

  public override ngOnInit(): void {
    this.modalStatesService.openModal(telegramAttachAllAdvertsModalName);
    this.initForm();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(telegramAttachAllAdvertsModalName);
  }

  public getTitle(): string {
    return `Привязать рекламы к TG менеджера ${this.dialogData.login}`;
  }

  public async handleAttachAll(): Promise<void> {
    const telegramAttachAllParams = this.setTelegramAttachAllParams();
    await this.telegramAttachAllService.telegramAttachAll(telegramAttachAllParams);
    this.closeDialog('cancel');
  }

  private initForm(): void {
    this.attachAllFormGroup = this.telegramAttachAllService.initForm(attachAllFormFields);
    this.attachAllFormGroup.get('dateTo' as string)?.setValue(new Date());
    this.attachAllFormGroup.get('force' as string)?.setValue(false);
  }

  private setTelegramAttachAllParams(): TelegramAttachAllParams {
    const dateFrom = this.attachAllFormGroup.get('dateFrom' as string)?.value;
    const dateTo = this.attachAllFormGroup.get('dateTo' as string)?.value;

    return {
      userId: this.dialogData.userId,
      dateFrom: formatDate(dateFrom, 'yyyy-MM-dd', 'en-US'),
      dateTo: formatDate(dateTo, 'yyyy-MM-dd', 'en-US'),
      force: this.attachAllFormGroup.get('force' as string)?.value || false
    };
  }

  public isDateValid(picker: MatDatepicker<Date>, key: string): void {
    const isBirthValid = this.validationService.compareDates({
      earlierDate: this.attachAllFormGroup.get('dateFrom' as string)?.value,
      laterDate: this.attachAllFormGroup.get('dateTo' as string)?.value,
      checkFutureDates: false
    });

    if (isBirthValid) { return; }

    this.attachAllFormGroup.get(key)?.setValue(null);
    this.errorService.showErrorMessage('Дата начала не может быть позже даты конца!');
    picker.close();
  }
}
